import { render, staticRenderFns } from "./Replacing.vue?vue&type=template&id=517df726&scoped=true"
import script from "./Replacing.vue?vue&type=script&lang=js"
export * from "./Replacing.vue?vue&type=script&lang=js"
import style0 from "./Replacing.vue?vue&type=style&index=0&id=517df726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517df726",
  null
  
)

export default component.exports